import React from 'react';
import Route from 'found/lib/Route';
import ViewerQuery from './ViewerQuery';
import { Loader } from '../components/Elements';
import EventListRoute from './_EventListRoute';
import EventCreateContainer from '../components/Event/Create/EventCreateContainer';
import EventShowContainer from '../components/Event/Show/EventShowContainer';
import EventOverviewContainer from '../components/Event/Show/EventOverviewContainer';
import EventSummaryContainer from '../components/Event/Show/EventSummaryContainer';
import WorkspacesContainer from '../components/Event/Show/Workspace/WorkspacesContainer';
import { graphql } from 'react-relay';

const EventRoutes = (
  <Route path='/events'>
    {EventListRoute}
    <Route
      path='new'
      Component={EventCreateContainer}
      query={ViewerQuery}
      render={({ props }) => (props ? <EventCreateContainer {...props} /> : <Loader />)}
    />
    <Route
      path=':event_id'
      prepareVariables={(params) => ({
        ...params,
        id: params.event_id
      })}
      Component={EventShowContainer}
      query={graphql`
        query EventRoutes_EventShow_Query($id: ID!) {
          viewer {
            ...EventShowContainer_viewer
          }
          node(id: $id) {
            ...EventShowContainer_node
          }
        }
      `}
      render={({ props }) => (props ? <EventShowContainer {...props} /> : <Loader />)}
    >
      <Route
        Component={EventOverviewContainer}
        prepareVariables={(params) => ({
          ...params,
          id: params.event_id
        })}
        query={graphql`
          query EventRoutes_EventOverview_Query($id: ID!) {
            viewer {
              ...EventOverviewContainer_viewer
            }
            node(id: $id) {
              ...EventOverviewContainer_node
            }
          }
        `}
        render={({ props }) => (props ? <EventOverviewContainer {...props} /> : <Loader />)}
      >
        <Route
          Component={EventSummaryContainer}
          prepareVariables={(params) => ({
            ...params,
            id: params.event_id
          })}
          query={graphql`
            query EventRoutes_EventSummary_Query($id: ID!) {
              viewer {
                ...EventSummaryContainer_viewer
              }
              node(id: $id) {
                ...EventSummaryContainer_node
              }
            }
          `}
          render={({ props }) => (props ? <EventSummaryContainer {...props} /> : <Loader />)}
        />
      </Route>
      <Route
        path='workspaces'
        Component={WorkspacesContainer}
        prepareVariables={(params) => ({
          ...params,
          id: params.event_id
        })}
        query={graphql`
          query EventRoutes_Workspace_Query($id: ID!) {
            viewer {
              ...WorkspacesContainer_viewer
            }
            node(id: $id) {
              ...WorkspacesContainer_node
            }
          }
        `}
        render={({ props }) => (props ? <WorkspacesContainer {...props} /> : <Loader />)}
      />
    </Route>
  </Route>
);

export default EventRoutes;



// WEBPACK FOOTER //
// ./webpack/routes/EventRoutes.js